document.addEventListener("DOMContentLoaded", function () {
  var form = document.getElementById("senseless-waitlist");
  var field = document.getElementById("senseless-contact-value");

  if (!form || !field) return;

  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  form.addEventListener("submit", function () {
    var value = field.value.trim();
    var isEmail = emailPattern.test(value);

    var hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = isEmail ? "contact[email]" : "contact[note]";
    hidden.value = isEmail ? value : "phone: " + value;
    form.appendChild(hidden);
  });
});
